import { getSaviorById } from "./getSaviorFunctions";
import { getArcanaById } from "./getArcanaFunctions";
import { LOCALES } from "../constants";
import { loadData } from "./dataLoader";
import GACHA_DATA from "../config/gacha.json";

let saviors;
let arcanas;

loadData("saviors.json").then((data) => (saviors = data));
loadData("arcanas.json").then((data) => (arcanas = data));

const PICKUP_TYPE = {
    PICKUP: "PICKUP",
    NON_PICKUP: "NON_PICKUP",
};

const SSR_TYPE = {
    COSMIC: "COSMIC",
    NOT_COSMIC: "NOT_COSMIC",
};

const GACHA_TYPE = {
    SAVIOR: "savior",
    ARCANA: "arcana",

    // 초기화시에만 사용
    SNIPE: "snipe",
};

const GRADE = {
    SSR: "SSR",
    SR: "SR",
    R: "R",
};

const GACHA_TABLE_NAME = {
    GRADE: "GRADE",
    PICKUP: "PICKUP",
    PICKUP_IS_COSMIC: "PICKUP_IS_COSMIC",
    COSMIC: "COSMIC",
    COSMIC_PICKUP: "COSMIC_PICKUP",

    SAVIOR_PICKUP_SSR_COSMIC: "SAVIOR_PICKUP_SSR_COSMIC",
    SAVIOR_PICKUP_SSR_NOT_COSMIC: "SAVIOR_PICKUP_SSR_NOT_COSMIC",
    SAVIOR_SSR_COSMIC: "SAVIOR_SSR_COSMIC",
    SAVIOR_SSR_NOT_COSMIC: "SAVIOR_SSR_NOT_COSMIC",
    SAVIOR_SR: "SAVIOR_SR",

    ARCANA_SSR: "ARCANA_SSR",
    ARCANA_SR: "ARCANA_SR",
};

const GACHA_TABLE = {
    GRADE: { SSR: 4, SR: 43, R: 53 },

    PICKUP: { PICKUP: 1, NON_PICKUP: 1 },
    PICKUP_IS_COSMIC: { PICKUP: 1, NON_PICKUP: 3 },

    COSMIC: { COSMIC: 5, NOT_COSMIC: 35 },
    COSMIC_PICKUP: { COSMIC: 5, NOT_COSMIC: 15 },

    SAVIOR_PICKUP_SSR_COSMIC: {},
    SAVIOR_PICKUP_SSR_NOT_COSMIC: {},
    SAVIOR_SSR_COSMIC: {},
    SAVIOR_SSR_NOT_COSMIC: {},
    SAVIOR_SR: {},

    ARCANA_SSR: {},
    ARCANA_SR: {},
};

const CACHE = {};

// GRADE판단 -> SSR일때
// isPickup = true인 경우
//      PICKUP성공실패 판단(50%확률) ->
//      픽뚫의 경우(PICKUP에서 FALSE등장) COSMIC_PICKUP 판단(픽업시 COSMIC 확률 20 중 5)
//      COSMIC인 경우 SAVIOR_PICKUP_SSR_COSMIC에서
//      COSMIC이 아닌 경우 SAVIOR_PICKUP_SSR_NOT_COSMIC에서 뽑음
// isPickup = false인 경우
//      COSMIC 판단(픽업이 아니므로 40 중 5)
//      COSMIC인 경우 SAVIOR_SSR_COSMIC에서
//      COSMIC이 아닌 경우 SAVIOR_SSR_NOT_COSMIC에서 뽑음
// 위 처럼 나눈 이유는 픽업인 경우 픽업은 항상 전체에서 2% 확률(SSR에서 50%확률)
// COSMIC 캐릭터는 픽업이든 아니든 전체에서 0.5% 확률(SSR에서 항상 5만큼의 비중)
// COSMIC이 아닌 캐릭터는 SSR내에서 나머지 비중을 동일하게 나눠먹음
// 따라서 픽업인 경우 픽업캐릭 2% 코즈믹 0.5%(동일비율분배) 일반캐릭 1.5%(동일비율분배)
// 픽업이 아닌 경우 코즈믹 0.5%(동일비율분배) 일반캐릭 3.5%(동일비율분배)
// SR의 경우 43비중 내에서 동일확률
// R의 경우 캐릭터에는 R등급이 없고 아르카나의 R등급이 등장하며 세부내용은 필요없으므로 등급만 출력
//
// 아르카나의 경우 COSMIC이 존재하지 않으며 픽업 제외 모두 동일 확률
// 따라서 픽업인 경우 SSR 픽업대상 2% 나머지 2%(동일비율분배),
// PICKUP으로 50% 판별하기 때문에 동일비율분배 객체 하나만으로 전부 처리 가능
// 픽업이 아닌 경우 SSR 4%(동일비율분배)

const init = () => {
    if (Object.keys(GACHA_TABLE.SAVIOR_SSR_COSMIC).length > 0) return;

    // 캐릭터 테이블(각 테이블 내 동일 확률)
    saviors
        .filter((savior) => !GACHA_DATA.NOT_IN_SAVIOR_COMMONS.includes(savior.id) && !GACHA_DATA.SAVIOR_PICKUPS.includes(savior.id))
        .forEach((savior) => {
            if (savior.rank === GRADE.SSR) {
                if (savior.attr === "NUAT_ORDER" || savior.attr === "NUAT_CHAOS") {
                    GACHA_TABLE.SAVIOR_SSR_COSMIC[savior.id] = 1;
                    GACHA_TABLE.SAVIOR_PICKUP_SSR_COSMIC[savior.id] = 1;
                } else {
                    GACHA_TABLE.SAVIOR_SSR_NOT_COSMIC[savior.id] = 1;
                    GACHA_TABLE.SAVIOR_PICKUP_SSR_NOT_COSMIC[savior.id] = 1;
                }
            } else {
                GACHA_TABLE.SAVIOR_SR[savior.id] = 1;
            }
        });

    arcanas
        .filter((arcana) => !GACHA_DATA.NOT_IN_ARCANA_COMMONS.includes(arcana.id) && !GACHA_DATA.ARCANA_PICKUPS.includes(arcana.id))
        .forEach((arcana) => {
            if (arcana.rarity === GRADE.SSR) {
                GACHA_TABLE.ARCANA_SSR[arcana.id] = 1;
            } else if (arcana.rarity === GRADE.SR) {
                GACHA_TABLE.ARCANA_SR[arcana.id] = 1;
            }
        });

    CACHE["GRADE"] = {
        keys: Object.keys(GACHA_TABLE.GRADE),
        total: Object.values(GACHA_TABLE.GRADE).reduce((prev, current) => prev + current),
    };
    CACHE["PICKUP"] = {
        keys: Object.keys(GACHA_TABLE.PICKUP),
        total: Object.values(GACHA_TABLE.PICKUP).reduce((prev, current) => prev + current),
    };
    CACHE["PICKUP_IS_COSMIC"] = {
        keys: Object.keys(GACHA_TABLE.PICKUP_IS_COSMIC),
        total: Object.values(GACHA_TABLE.PICKUP_IS_COSMIC).reduce((prev, current) => prev + current),
    };
    CACHE["COSMIC"] = {
        keys: Object.keys(GACHA_TABLE.COSMIC),
        total: Object.values(GACHA_TABLE.COSMIC).reduce((prev, current) => prev + current),
    };
    CACHE["COSMIC_PICKUP"] = {
        keys: Object.keys(GACHA_TABLE.COSMIC_PICKUP),
        total: Object.values(GACHA_TABLE.COSMIC_PICKUP).reduce((prev, current) => prev + current),
    };

    CACHE["SAVIOR_PICKUP_SSR_COSMIC"] = {
        keys: Object.keys(GACHA_TABLE.SAVIOR_PICKUP_SSR_COSMIC),
        total: Object.values(GACHA_TABLE.SAVIOR_PICKUP_SSR_COSMIC).reduce((prev, current) => prev + current),
    };
    CACHE["SAVIOR_PICKUP_SSR_NOT_COSMIC"] = {
        keys: Object.keys(GACHA_TABLE.SAVIOR_PICKUP_SSR_NOT_COSMIC),
        total: Object.values(GACHA_TABLE.SAVIOR_PICKUP_SSR_NOT_COSMIC).reduce((prev, current) => prev + current),
    };
    CACHE["SAVIOR_SSR_COSMIC"] = {
        keys: Object.keys(GACHA_TABLE.SAVIOR_SSR_COSMIC),
        total: Object.values(GACHA_TABLE.SAVIOR_SSR_COSMIC).reduce((prev, current) => prev + current),
    };
    CACHE["SAVIOR_SSR_NOT_COSMIC"] = {
        keys: Object.keys(GACHA_TABLE.SAVIOR_SSR_NOT_COSMIC),
        total: Object.values(GACHA_TABLE.SAVIOR_SSR_NOT_COSMIC).reduce((prev, current) => prev + current),
    };
    CACHE["SAVIOR_SR"] = {
        keys: Object.keys(GACHA_TABLE.SAVIOR_SR),
        total: Object.values(GACHA_TABLE.SAVIOR_SR).reduce((prev, current) => prev + current),
    };

    CACHE["ARCANA_SSR"] = {
        keys: Object.keys(GACHA_TABLE.ARCANA_SSR),
        total: Object.values(GACHA_TABLE.ARCANA_SSR).reduce((prev, current) => prev + current),
    };
    CACHE["ARCANA_SR"] = {
        keys: Object.keys(GACHA_TABLE.ARCANA_SR),
        total: Object.values(GACHA_TABLE.ARCANA_SR).reduce((prev, current) => prev + current),
    };
};

const buffer = new Uint32Array(1);

const getRandom = (max) => {
    crypto.getRandomValues(buffer);
    return (buffer[0] % max) + 1;
};

const getRandomPick = (tableName) => {
    const max = CACHE[tableName].total;
    const rand = getRandom(max);

    const table = GACHA_TABLE[tableName];
    const keys = CACHE[tableName].keys;
    let acc = 0;

    for (let i = 0; i < keys.length; i++) {
        const target = keys[i];
        acc += table[target];

        if (rand <= acc) {
            return target;
        }
    }
};

const getSaviorPick = (lang, isPickup, ssrType, pickupIndex) => {
    const grade = getRandomPick(GACHA_TABLE_NAME.GRADE);

    if (grade === GRADE.SSR) {
        if (isPickup) {
            // 픽업 뽑기
            const pickupTableName = ssrType === SSR_TYPE.COSMIC ? GACHA_TABLE_NAME.PICKUP_IS_COSMIC : GACHA_TABLE_NAME.PICKUP;

            if (getRandomPick(pickupTableName) === PICKUP_TYPE.PICKUP) {
                // 픽업 캐릭터 등장
                const id = GACHA_DATA.SAVIOR_PICKUPS[pickupIndex];
                const savior = getSaviorById(id);
                console.log(savior, id, pickupIndex);
                return {
                    id: id,
                    name: `${savior.name[lang]}(${savior.title[lang]})`,
                    img: `${savior.name[LOCALES.KO]}(${savior.title[LOCALES.KO]})`,
                    isPickup: true,
                    isSSR: true,
                };
            } else {
                // 픽업 캐릭터 미등장
                const ssrType = getRandomPick(GACHA_TABLE_NAME.COSMIC_PICKUP);

                if (ssrType === SSR_TYPE.COSMIC) {
                    // 픽뚫 + 코즈믹SSR
                    const id = Number(getRandomPick(GACHA_TABLE_NAME.SAVIOR_PICKUP_SSR_COSMIC));
                    const savior = getSaviorById(id);

                    return {
                        id: id,
                        name: `${savior.name[lang]}(${savior.title[lang]})`,
                        img: `${savior.name[LOCALES.KO]}(${savior.title[LOCALES.KO]})`,
                        isPickup: false,
                        isSSR: true,
                    };
                } else {
                    // 픽뚫 + 일반SSR
                    const id = Number(getRandomPick(GACHA_TABLE_NAME.SAVIOR_PICKUP_SSR_NOT_COSMIC));
                    const savior = getSaviorById(id);

                    return {
                        id: id,
                        name: `${savior.name[lang]}(${savior.title[lang]})`,
                        img: `${savior.name[LOCALES.KO]}(${savior.title[LOCALES.KO]})`,
                        isPickup: false,
                        isSSR: true,
                    };
                }
            }
        } else {
            // 일반 뽑기
            const ssrType = getRandomPick(GACHA_TABLE_NAME.COSMIC);

            if (ssrType === SSR_TYPE.COSMIC) {
                // 코즈믹SSR
                const id = Number(getRandomPick(GACHA_TABLE_NAME.SAVIOR_SSR_COSMIC));
                const savior = getSaviorById(id);

                return {
                    id: id,
                    name: `${savior.name[lang]}(${savior.title[lang]})`,
                    img: `${savior.name[LOCALES.KO]}(${savior.title[LOCALES.KO]})`,
                    isPickup: false,
                    isSSR: true,
                };
            } else {
                // 일반SSR
                const id = Number(getRandomPick(GACHA_TABLE_NAME.SAVIOR_SSR_NOT_COSMIC));
                const savior = getSaviorById(id);

                return {
                    id: id,
                    name: `${savior.name[lang]}(${savior.title[lang]})`,
                    img: `${savior.name[LOCALES.KO]}(${savior.title[LOCALES.KO]})`,
                    isPickup: false,
                    isSSR: true,
                };
            }
        }
    } else if (grade === GRADE.SR) {
        const id = Number(getRandomPick(GACHA_TABLE_NAME.SAVIOR_SR));
        const savior = getSaviorById(id);

        return {
            id: id,
            name: `${savior.name[lang]}(${savior.title[lang]})`,
            img: `${savior.name[LOCALES.KO]}(${savior.title[LOCALES.KO]})`,
            isPickup: false,
            isSSR: false,
        };
    } else {
        return { id: GRADE.R };
    }
};

const getArcanaPick = (lang, isPickup = false, pickupIndex) => {
    const grade = getRandomPick(GACHA_TABLE_NAME.GRADE);

    if (grade === GRADE.SSR) {
        if (isPickup && getRandomPick(GACHA_TABLE_NAME.PICKUP) === PICKUP_TYPE.PICKUP) {
            const id = GACHA_DATA.ARCANA_PICKUPS[pickupIndex];
            const arcana = getArcanaById(id);

            return {
                id: id,
                name: arcana.name[lang],
                img: arcana.name[LOCALES.KO],
                isPickup: true,
                isSSR: true,
            };
        }

        const id = Number(getRandomPick(GACHA_TABLE_NAME.ARCANA_SSR));
        const arcana = getArcanaById(id);

        return {
            id: id,
            name: arcana.name[lang],
            img: arcana.name[LOCALES.KO],
            isPickup: false,
            isSSR: true,
        };
    } else if (grade === GRADE.SR) {
        const id = Number(getRandomPick(GACHA_TABLE_NAME.ARCANA_SR));
        const arcana = getArcanaById(id);

        return {
            id: id,
            name: arcana.name[lang],
            img: arcana.name[LOCALES.KO],
            isPickup: false,
            isSSR: false,
        };
    } else {
        return { id: GRADE.R };
    }
};

const tryGacha = (lang, gachaType, isPickup = false, ssrType = SSR_TYPE.NOT_COSMIC, pickupIndex) => {
    init();

    if (gachaType === GACHA_TYPE.SAVIOR) {
        return getSaviorPick(lang, isPickup, ssrType, pickupIndex);
    } else if (gachaType === GACHA_TYPE.ARCANA) {
        return getArcanaPick(lang, isPickup, pickupIndex);
    }

    return "";
};

export { GACHA_TYPE, GRADE, SSR_TYPE, tryGacha };
